import { useContext, useState } from "react";
import { ParameterContext } from '../../contexts/ParameterContext';
import { useEffect } from "react";
import * as paramService from '../services/parameterService'

export default function SettingsForm() {

    const [nomParams, setNomParams] = useState([]);

    useEffect(() => {
        paramService.getParamsAdmin()
            .then((data) => {
                setNomParams(data);
            })
    }, [])

    return (
        <div className="col-12">
            <div className="overflow-auto card recent-sales">
                <div className="card-body">
                    <h5 className="card-title"><span>Списък от настройки на системата</span></h5>

                    {(!nomParams) ? (<p>...</p>) : (
                        <>
                            <table className="table table-striped table-hover w-100">
                                <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">Параметър</th>
                                        <th scope="col">Стойност</th>
                                        <th scope="col">Описание</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {nomParams.map((p, index) => (
                                        <tr key={index + 1}>
                                            <td>{index + 1}</td>
                                            <td>{p.paraM_NAME}</td>
                                            <td>{p.value}</td>
                                            <td>{p.paraM_FULL_NAME}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </>
                    )}

                </div>
            </div>
        </div>
    )
}